import axios from '@/utils/axios'
import queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
        permissions: null,
    },
    mutations: {
        setPermissions(state, payload) {
            state.permissions = payload;
        }
    }, 
    actions: {
        fetchPermissions({ commit, rootState, dispatch}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `auth/permissions?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setPermissions', response.data);
                    resolve(response)
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                } 
                );
            })
        }
    }
}